/**
 * arena.ts — arena dimensions, shared so the client's meshes and the server's
 * Rapier colliders are generated from one description and cannot drift.
 */
export const ARENA = {
    /** Ground is a square centred on the origin, this many m per side. */
    size: 30,
    /**
     * Wall height, m — and so the ceiling, which sits on it.
     *
     * A hall, not a cellar. At 4m the vault was close enough overhead to feel
     * like a lid: an overhead swing carries a duellist's hands past 2.5m and the
     * tip most of the way to the stone, so the room read as cramped in exactly
     * the situation it should read as open. Everything vertical is derived from
     * this — the wall colliders, the masonry courses, the ceiling plane and its
     * ribs — so raising the room is this number and nothing else. A whole number
     * of BLOCK_H courses, so the top course lands flush with the ceiling.
     */
    wallHeight: 6.5,
    /** Wall thickness, m. */
    wallThickness: 0.5,
};
const h = ARENA.wallHeight / 2;
const t = ARENA.wallThickness / 2;
const e = ARENA.size / 2 + t;
/** The four perimeter walls, as boxes. */
export const ARENA_WALLS = [
    { pos: [0, h, -e], halfExtents: [e, h, t] },
    { pos: [0, h, e], halfExtents: [e, h, t] },
    { pos: [-e, h, 0], halfExtents: [t, h, e] },
    { pos: [e, h, 0], halfExtents: [t, h, e] },
];
/** Spawn points, spread around the arena so joiners never overlap. */
export const SPAWN_POINTS = [
    [-8, 0, -8],
    [8, 0, 8],
    [8, 0, -8],
    [-8, 0, 8],
    [0, 0, -10],
    [0, 0, 10],
    [-10, 0, 0],
    [10, 0, 0],
];
//# sourceMappingURL=arena.js.map